// Drunativa ahora vive en Google Play. Esta web solo muestra el aviso,
// la política de privacidad (/privacy.html) y la configuración de banners de la app.
const PLAY_URL =
  "https://play.google.com/store/apps/details?id=com.looptopus.drunativapro";

export default function App() {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#FFD900",
        color: "#000",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "32px 16px",
        boxSizing: "border-box",
        textAlign: "center",
        fontFamily: "'Nunito Sans', Arial, sans-serif",
      }}
    >
      <img
        src="/Logo_DRUNATIVA.png"
        alt="Drunativa"
        style={{ width: "80%", maxWidth: 420, height: "auto", marginBottom: 28 }}
      />
      <h1 style={{ fontSize: 24, fontWeight: 700, margin: "0 0 10px" }}>
        Drunativa ya está en Google Play
      </h1>
      <p style={{ fontSize: 16, margin: "0 0 28px", maxWidth: 420, lineHeight: 1.5 }}>
        Drum pad y secuenciador con percusión nativoamericana y latina. Descárgala gratis.
      </p>
      <a
        href={PLAY_URL}
        style={{
          background: "#000",
          color: "#FFD900",
          textDecoration: "none",
          fontWeight: 700,
          fontSize: 16,
          padding: "14px 28px",
          borderRadius: 10,
        }}
      >
        Descargar en Google Play
      </a>
      <p style={{ fontSize: 13, marginTop: 40, opacity: 0.7 }}>
        by Looptopus · <a href="/privacy.html" style={{ color: "#000" }}>Política de privacidad</a>
      </p>
    </div>
  );
}
